import { Order } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { WalletAddress } from '@root/entities/wallet/model'

import type { WalletsTrackerGetTrackingWalletsListData } from '@blade/trade-api-client'
import type { Address } from '@root/entities/address/Address'

export interface TrackingWallet {
  label: string
  walletAddress: Address
  createdAt: Date
  updatedAt: Date
  tags: Array<string>
  emoji: string
  network: Network.Network
  alertsEnabled: boolean
}

export const fromDto = (
  dto: WalletsTrackerGetTrackingWalletsListData[number],
): TrackingWallet => {
  return {
    label: dto.label,
    walletAddress: WalletAddress(dto.walletAddress),
    createdAt: new Date(dto.createdAt),
    updatedAt: new Date(dto.updatedAt),
    tags: dto.tags,
    emoji: dto.emoji,
    network: Network.fromDto(dto.network),
    alertsEnabled: dto.alertsEnabled,
  }
}

export const toDto = (
  wallet: TrackingWallet,
): WalletsTrackerGetTrackingWalletsListData[number] => {
  return {
    label: wallet.label,
    walletAddress: wallet.walletAddress.toString(),
    createdAt: wallet.createdAt.toISOString(),
    updatedAt: wallet.updatedAt.toISOString(),
    tags: wallet.tags,
    emoji: wallet.emoji,
    network: Network.toDto(wallet.network),
    alertsEnabled: wallet.alertsEnabled,
  }
}

export const createdAt = (wallet: TrackingWallet) => wallet.createdAt

export const cmpCreatedAt = Order.mapInput(Order.Date, createdAt)
export const cmpCreatedAtDesc = Order.flip(cmpCreatedAt)
